export default class License {
    constructor(values) {
        Object.assign(this, values);
        this.valid = new Date(values.valid);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Licenses/Model.ts
// module id = 153
// module chunks = 0